import React from 'react';
// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { FileSearchOutlined, UploadOutlined } from '@ant-design/icons';

// icons
const icons = {
    FileSearchOutlined,
    UploadOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const shortTermRental = {
    id: 'short_term_rental',
    title: <FormattedMessage id="rentals" />,
    type: 'group',
    children: [
        {
            id: 'rentals',
            title: <FormattedMessage id="rentals table" />,
            type: 'item',
            url: '/rentals',
            icon: icons.FileSearchOutlined
        }
    ]
};

export default shortTermRental;
